<div fxLayout="row wrap">
  <span *ngIf="first">{{first}}&nbsp;</span>
  <strong class="__hard" *ngIf="second">{{second}}</strong>

  <ng-content></ng-content>
  <b class="__last">*</b>
</div>
